import { IconProps } from "./";
import Icon from "./assets/left_chevron_16.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon16ChevronLeft(props: IconProps) {
  return <BaseIcon className="text-lg" icon={<Icon />} {...props} />;
}
